import { FooterYear } from './FooterYear';

interface FooterProps {
  theme?: 'light' | 'dark'
}

const FooterMarkSvg = () => (
  <svg viewBox="0 0 27 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.36276 18.7476L0 33.1253L16.6313 33.1768L8.36276 18.7476Z" fill="currentColor"/>
    <path d="M8.3798 14.4292L16.7426 0.0514104L0.111289 0L8.3798 14.4292Z" fill="currentColor"/>
    <path d="M10.2478 15.5089L26.879 15.5689L18.6105 1.13966L10.2478 15.5089Z" fill="currentColor"/>
    <path d="M10.2394 17.6765L18.5079 32.1057L26.8707 17.7279L10.2394 17.6765Z" fill="currentColor"/>
  </svg>
)

const XIcon = () => (
  <svg aria-hidden="true" focusable="false" width="24" height="21" viewBox="0 0 24 21" fill="none">
    <path d="M18.901 0H22.581L14.541 8.892L24 20.5H16.594L10.794 13.338L4.156 20.5H0.474L9.074 11.01L0 0H7.594L12.837 6.526L18.901 0ZM17.61 18.42H19.649L6.486 2.088H4.298L17.61 18.42Z" fill="currentColor"/>
  </svg>
)

const FacebookIcon = () => (
  <svg aria-hidden="true" focusable="false" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path d="M21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 15.7377 3.83908 20.0634 8.85938 20.8542V13.5352H6.19336V10.5H8.85938V8.18555C8.85938 5.55164 10.4233 4.10156 12.8238 4.10156C13.9712 4.10156 15.1719 4.30664 15.1719 4.30664V6.89063H13.8483C12.5499 6.89063 12.1406 7.69266 12.1406 8.51563V10.5H15.0488L14.5816 13.5352H12.1406V20.8542C17.1609 20.0634 21 15.7377 21 10.5Z" fill="currentColor"/>
  </svg>
)

const YouTubeIcon = () => (
  <svg aria-hidden="true" focusable="false" width="29" height="21" viewBox="0 0 29 21" fill="none">
    <path d="M28.4047 3.27831C28.0815 2.04212 27.1135 1.06472 25.8893 0.737824C23.6458 0.141602 14.5604 0.141602 14.5604 0.141602C14.5604 0.141602 5.47497 0.141602 3.23152 0.737824C2.00732 1.06477 1.03929 2.04212 0.716093 3.27831C0.125 5.54047 0.125 10.2607 0.125 10.2607C0.125 10.2607 0.125 14.9808 0.716093 17.243C1.03929 18.4792 2.00732 19.4177 3.23152 19.7446C5.47497 20.3408 14.5604 20.3408 14.5604 20.3408C14.5604 20.3408 23.6458 20.3408 25.8893 19.7446C27.1135 19.4177 28.0815 18.4792 28.4047 17.243C28.9958 14.9808 28.9958 10.2607 28.9958 10.2607C28.9958 10.2607 28.9958 5.54047 28.4047 3.27831ZM11.6197 14.5614V5.95995L19.1316 10.2608L11.6197 14.5614Z" fill="currentColor"/>
  </svg>
)

export function Footer({ theme = 'light' }: FooterProps) {
  return (
    <footer className={`site-footer${theme === 'dark' ? ' site-footer--dark' : ''}`}>
      <div className="site-footer__inner">

        <div className="site-footer__mark">
          <FooterMarkSvg />
        </div>

        <nav aria-label="Footer navigation">
          <div className="site-footer__links">

            <div className="site-footer__col-group">
              <div className="site-footer__col">
                <span className="site-footer__heading type-eyebrow-md">Platform</span>
                <a href="https://innovaccer.com/data-activation-platform">Data Activation Platform</a>
                <a href="https://innovaccer.com/sara">Sara AI</a>
                <a href="https://innovaccer.com/data-activation-platform">Integrations</a>
              </div>
              <div className="site-footer__col">
                <span className="site-footer__heading type-eyebrow-md">Security &amp; Trust</span>
                <a href="https://innovaccer.com/trust-center">Compliance</a>
                <a href="https://innovaccer.com/trust-center">Security</a>
                <a href="https://innovaccer.com/privacy">Privacy</a>
              </div>
            </div>

            <div className="site-footer__col">
              <span className="site-footer__heading type-eyebrow-md">Products</span>
              <a href="https://innovaccer.com/accelerators/population-health-analytics">Population Health</a>
              <a href="https://innovaccer.com/solutions/care-management">Care Management</a>
              <a href="https://innovaccer.com/solutions/financial-analytics">Contract Management</a>
              <a href="https://innovaccer.com/solutions/consumer-patient-experience">Omnichannel Comms</a>
              <a href="https://innovaccer.com/solutions/customer-relationship-management">CRM &amp; Access Center</a>
              <a href="https://www.cured.health/provider-relationship-management">Network Management</a>
              <a href="https://inscribe.innovaccer.com">Provider Copilot</a>
              <a href="https://inscribe.innovaccer.com">Care Management Copilot</a>
              <a href="https://inscribe.innovaccer.com">Patient Access Copilot</a>
            </div>

            <div className="site-footer__col">
              <span className="site-footer__heading type-eyebrow-md">Teams</span>
              <a href="https://innovaccer.com/solutions/population-health">Population Health</a>
              <a href="https://innovaccer.com/solutions/marketing">Marketing</a>
              <a href="https://innovaccer.com/solutions/access">Access</a>
              <a href="https://innovaccer.com/provider-productivity">Clinical</a>
              <a href="https://innovaccer.com/healthcare-experience">Experience</a>
              <a href="https://innovaccer.com/solutions/provider-engagement">Provider Engagement</a>
              <a href="https://innovaccer.com/solutions/financial-analytics">Contracting</a>
              <a href="https://innovaccer.com/products/care-management">Case Management</a>
            </div>

            <div className="site-footer__col">
              <span className="site-footer__heading type-eyebrow-md">Industries</span>
              <a href="https://innovaccer.com/solutions/provider">Provider</a>
              <a href="https://innovaccer.com/solutions/payer-old">Payer</a>
              <a href="https://innovaccer.com/solutions/government-old">Public Sector</a>
              <a href="https://innovaccer.com/solutions/life-sciences">Life Sciences</a>
            </div>

            <div className="site-footer__col">
              <span className="site-footer__heading type-eyebrow-md">Resources</span>
              <a href="https://innovaccer.com/blogs">Resource Hub</a>
              <a href="https://innovaccer.com/events">Events</a>
              <a href="https://innovaccer.com/case-studies">Customers</a>
              <a href="https://innovaccer.com/glossary">Innovaccer University</a>
              <a href="https://innovaccer.com/industry-reports">Industry Reports</a>
            </div>

            <div className="site-footer__col">
              <span className="site-footer__heading type-eyebrow-md">Company</span>
              <a href="https://innovaccer.com/about">About</a>
              <a href="https://innovaccer.com/careers">Careers</a>
              <a href="https://innovaccer.com/news">Press</a>
              <a href="https://innovaccer.com/contact-us">Contact Us</a>
              <a href="https://innovaccer.com/partners">Partners</a>
            </div>

          </div>
        </nav>

        <hr className="site-footer__divider" />

        <div className="site-footer__bottom">
          <div className="site-footer__social">
            <a href="https://x.com/innovaccer" aria-label="X (Twitter)"><XIcon /></a>
            <a href="https://www.facebook.com/Innovaccer" aria-label="Facebook"><FacebookIcon /></a>
            <a href="https://www.youtube.com/channel/UCl3JT1Wm_MHu20T37UgZs8w" aria-label="YouTube"><YouTubeIcon /></a>
          </div>
          <div className="site-footer__legal">
            <span>Innovaccer &copy; <FooterYear fallback={new Date().getFullYear()} /></span>
            <a href="https://innovaccer.com/terms-of-use">Terms</a>
            <a href="https://innovaccer.com/privacy">Privacy</a>
          </div>
        </div>

      </div>
    </footer>
  )
}
